import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';



@Injectable({
  providedIn: 'root'
})
export class GoogleMapService {
  private googleMapsApiLoaded = false;

  constructor(private http: HttpClient,) {
  }

  load(): Observable<void> {
    return new Observable((observer) => {
      if (this.googleMapsApiLoaded) {
        observer.next();
        observer.complete();
        return;
      }

      // Create a script element to load the Google Maps API
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapKey}&libraries=places`; // Replace with your API key
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.googleMapsApiLoaded = true;
        observer.next();
        observer.complete();
      };

      script.onerror = (error) => {
        observer.error(error);
      };

      // Append the script to the body to load the Google Maps API
      document.body.appendChild(script);
    });
  }

  async getGooglePlaceAutoCompleteList(searchText, city_bounds?) {
    const autocompleteService = new window['google'].maps.places.AutocompleteService();

    let pred;
    const latLngBounds = city_bounds;
    await new Promise((resolve, reject) => {
      autocompleteService.getPlacePredictions({
        input: searchText,
        bounds: latLngBounds,
        strictBounds: true,
        types: ['establishment', 'geocode']
      }, (predictions) => {
        pred = predictions;
        resolve(true);
      });
    });
    console.log("predictions: ", pred);
    return pred;
  }


  getCurrentLocation(): Observable<any> {
    return new Observable(observer => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            console.log('Current Location:', latitude, longitude);

            this.reverseGeocode(latitude, longitude).subscribe(
              (response: any) => {
                if (response.results.length > 0) {
                  const deviceLocation = {
                    lat: latitude,
                    lng: longitude,
                    address: response.results[0].formatted_address,
                    accuracy: position.coords.accuracy
                  };
                  console.log('Updated Location:', deviceLocation);
                  observer.next(deviceLocation); // Send data to subscriber
                  observer.complete(); // Mark Observable as finished
                }
              },
              (error) => {
                observer.error(error);
              }
            );
          },
          (error) => {
            observer.error(error);
          },
          {
            enableHighAccuracy: true,
            timeout: 30000, // Report error if no position update within 30 seconds
            maximumAge: 30000, // Use a cached position up to 30 seconds old
          }
        );
      } else {
        observer.error('Geolocation not supported.');
      }
    });
  }

  reverseGeocode(lat: number, lng: number): Observable<any> {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${environment.googleMapKey}`;
    return this.http.get(url);
  }
}

export interface Position {
  lat: number;
  lng: number;
  address?: string;
  accuracy?: number;
}